export const PAYPAL_URL = (paypal_client_id) =>
  `https://www.paypal.com/sdk/js?client-id=${paypal_client_id}&vault=true&intent=subscription`;
